import type { SVGProps } from 'react';

const SvgCustomAction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 7v3c0 .55.45 1 1 1s1-.45 1-1V7c0-2.21-1.79-4-4-4H7C4.79 3 3 4.79 3 7v4c0 2.21 1.79 4 4 4h3c.55 0 1-.45 1-1s-.45-1-1-1H7c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2"
    />
    <path
      fill="currentcolor"
      d="m13.71 8.29-2-2A.996.996 0 1 0 10.3 7.7l1.29 1.29-1.29 1.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2-2a.996.996 0 0 0 0-1.41zM15 17v-3c0-.55-.45-1-1-1s-1 .45-1 1v3c-.55 0-1 .45-1 1s.45 1 1 1v1c0 .55.45 1 1 1s1-.45 1-1v-1c.55 0 1-.45 1-1s-.45-1-1-1m5-2v-1c0-.55-.45-1-1-1s-1 .45-1 1v1c-.55 0-1 .45-1 1s.45 1 1 1v3c0 .55.45 1 1 1s1-.45 1-1v-3c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgCustomAction;
